<template>
  <path
    v-if="direction === 'right'"
    d="M1.12977 18.9892C0.850093 18.9892 0.550093 18.8892 0.329773 18.6689C-0.110067 18.2291 -0.110067 17.5291 0.329773 17.0892L7.90937 9.48922L0.329773 1.90962C-0.110067 1.46978 -0.110067 0.769779 0.329773 0.329939C0.769613 -0.109901 1.46961 -0.109901 1.90945 0.329939L10.2891 8.68934C10.5094 8.90966 10.6094 9.18934 10.6094 9.48934C10.6094 9.78934 10.4891 10.069 10.2891 10.2893L1.90945 18.6689C1.68913 18.8893 1.40945 18.9893 1.12977 18.9893V18.9892Z"
    fill="inherit"
  />
  <path
    v-else-if="direction === 'left'"
    d="M9.87023 18.9892C10.1499 18.9892 10.4499 18.8892 10.6702 18.6689C11.1101 18.2291 11.1101 17.5291 10.6702 17.0892L3.09063 9.48922L10.6702 1.90962C11.1101 1.46978 11.1101 0.769779 10.6702 0.329939C10.2304 -0.109901 9.53039 -0.109901 9.09055 0.329939L0.710945 8.68934C0.490625 8.90966 0.390625 9.18934 0.390625 9.48934C0.390625 9.78934 0.510937 10.069 0.710945 10.2893L9.09055 18.6689C9.31087 18.8893 9.59055 18.9893 9.87023 18.9893V18.9892Z"
    fill="inherit"
  />
</template>

<script>
export default {
  name: 'icon-arrow',
  props: {
    direction: {
      type: String,
      default: 'right',
    },
  },
}
</script>
